import i18n from '@/i18n'

const baseURL = import.meta.env.VITE_APP_API_URL.replace(/\/$/, '')

const parseBody = async (response: Response) => {
  const text = await response.text()

  try {
    return JSON.parse(text)
  } catch {
    return text
  }
}

const request = async <T>(url: string, init: RequestInit = {}) => {
  const requestUrl = new URL(`${baseURL}/${url.replace(/^\//, '')}`)

  if (!requestUrl.searchParams.has('lang')) {
    requestUrl.searchParams.set('lang', i18n.global.locale.value)
  }

  const response = await fetch(requestUrl, {
    ...init,
    headers: {
      Accept: 'application/json',
      ...init.headers,
    },
  })
  const data = (await parseBody(response)) as T

  if (!response.ok) {
    const error = new Error(`Request failed with status ${response.status}`)
    ;(error as Error & { response: { status: number; data: T } }).response = {
      status: response.status,
      data,
    }
    throw error
  }

  return { status: response.status, data }
}

const http = {
  get: <T>(url: string, init?: RequestInit) => request<T>(url, init),
}

export { http }
